export const LOGIN_USER = "LOGIN_USER"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"

export const LOGOUT_USER = "LOGOUT_USER"
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS"
export const API_ERROR = "LOGIN_API_ERROR"

export const SOCIAL_LOGIN = "SOCIAL_LOGIN"

export const USER_DETAIL = "USER_DETAIL"
export const USER_DETAIL_SUCCESS = "USER_DETAIL_SUCCESS"
export const USER_DETAIL_ERROR = "USER_DETAIL_ERROR"


export const CLIENT_DETAILS = "CLIENT_DETAILS"
export const CLIENT_DETAILS_SUCCESS = "CLIENT_DETAILS_SUCCESS"
export const CLIENT_DETAILS_ERROR = "CLIENT_DETAILS_ERROR"